module.exports = __webpack_public_path__ + "static/media/adporras.32076a84.jpg";